// extracted by mini-css-extract-plugin
export default {"foundBugsContent":"overviewPage_foundBugsContent__0-ewI"};